<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		methods: {
			loginStatus() {
				if (this.$helper.get("tokenInfo")) {
					this.$store.commit("$vuexSetLoginState", true);
					this.$store.commit("$vuexUserInfo", this.$helper.get("userInfo"));
					this.head_userInfo = this.$store.state.userInfo;
					this.updateUserInfo();
				} else {
					this.$store.commit("$vuexSetLoginState", false);
				}
			},
		},
		mounted() {
			this.loginStatus();
		}
	}
</script>
<style scoped>
</style>